import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import type {MetaType} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import useModals from '../../../../hooks/useModals'
import {DELETE, GET, POST, PUT} from '../../../../services/api'
import {Loading} from '../../../../components/Loading/Loading'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import {useNavigate} from 'react-router-dom'
import Swal from 'sweetalert2'
import {i18n} from '../../../../translate/i18n'
import {BreadCrumbs} from '../../../../components/BreadCrumbs/breadCrumbrs'
import {useSwitchStatus} from '../../../../components/Datatable/SwitchStatus'
import {intervalValue} from '../../ContentStructured/GridHotel/hooks/dateHour'
import {set} from 'rsuite/esm/internals/utils/date'

type GridResponseType = {
  id: number
  title: string
  status: boolean
  startHour: string
  endHour: string
  interval: number
}

const GradesHotelFeedBackContent: FC = () => {
  const navigate = useNavigate()
  const {showDeleteModal} = useModals()
  const [loading, setLoading] = useState(false)
  const {switchStatus} = useSwitchStatus()
  const [grids, setGrids] = useState<GridResponseType[]>([])
  const [id, setId] = useState<number | null>(null)
  const [meta, setMeta] = useState<MetaType | undefined>(undefined)

  const getGridsFeedBack = async () => {
    try {
      setLoading(true)
      const res = await GET(`/grid-hotel-feedback`)
      const news = res.data.map((row: GridResponseType) => {
        return {
          id: row.id,
          title: row.title,
          status: row.status,
        }
      })
      setGrids(news)
      setMeta(res.meta)
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const canDelete = async () => {
    try {
      setLoading(true)
      // const res = await GET(`/grid-hotel-feedback/${id}`)
      await deleteGrid()
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }

  const deleteGrid = async () => {
    try {
      setLoading(true)
      const gridRes = await DELETE(`/grid-hotel-feedback/${id}`)
      if (gridRes.success === true) {
        Swal.fire({
          icon: 'success',
          title: i18n.t(`gridHotelFeedback.grid_deleted`) as string,
          text: i18n.t(`gridHotelFeedback.grid_deleted_message`) as string,
        }).then(async () => await getGridsFeedBack())
      } else {
        Swal.fire({
          icon: 'error',
          title: i18n.t(`gridHotelFeedback.error`) as string,
          text: i18n.t(`gridHotelFeedback.error_delete_message`) as string,
        }).then(async () => await getGridsFeedBack())
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: i18n.t(`gridHotelFeedback.error`) as string,
        text: i18n.t(`gridHotelFeedback.error_delete_message`) as string,
      }).then(async () => await getGridsFeedBack())
      console.log(e)
    }
  }

  useEffect(() => {
    getGridsFeedBack()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>
                  {i18n.t(`gridHotelFeedback.service_grid`)}
                </span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {i18n.t(`gridHotelFeedback.listed_grids`)}
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text={i18n.t(`gridHotelFeedback.create_service_grid`)}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() =>
                    navigate('/hospitality/feedback-satisfaction/grid-hotel-feedback/create')
                  }
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <Datatable
                data={grids}
                headers={[
                  {key: i18n.t(`gridHotelFeedback.title`), value: 'title', type: 'default'},
                  {
                    key: i18n.t(`gridHotelFeedback.status`),
                    value: 'status',
                    type: 'check',
                    action: (item: any) =>
                      switchStatus({
                        endpoint: 'grid-hotel-feedback/status',
                        Id: item.id,
                        status: item.status,
                      }),
                  },
                  {key: i18n.t(`gridHotelFeedback.general.actions`), value: 'acoes', type: ''},
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    action: (item) => {
                      navigate(
                        `/hospitality/feedback-satisfaction/grid-hotel-feedback/edit/${item.id}`
                      )
                    },
                    title: `${i18n.t(`gridHotelFeedback.general.edit`)} ${i18n.t(
                      `gridHotelFeedback.service_grid_single`
                    )}`,
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item) => {
                      showDeleteModal(
                        `${i18n.t(`gridHotelFeedback.general.delete`)} ${i18n.t(
                          `gridHotelFeedback.service_grid_single`
                        )}`
                      )
                      setId(item.id)
                    },
                    title: `${i18n.t(`gridHotelFeedback.general.delete`)} ${i18n.t(
                      `gridHotelFeedback.service_grid_single`
                    )}`,
                  },
                ]}
                color='primary'
              />
            </div>
          </div>

          <ModalDelete confirmAction={() => canDelete()} />
        </div>
      )}
    </>
  )
}

const GradesFeedBackHotel: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: i18n.t(`gridHotelFeedback.dashboard`) as string,
            path: 'dashboard',
            isActive: true,
          },
          {title: i18n.t(`gridHotelFeedback.service_grid`) as string, path: 'grid', isActive: true},
        ]}
      >
        {i18n.t(`gridHotelFeedback.service_grid`)}
      </PageTitle>
      <GradesHotelFeedBackContent />
    </>
  )
}

export {GradesFeedBackHotel}
